module.exports = __webpack_public_path__ + "static/media/icon-header-default.7cb2ec22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-default.svg
// module id = 1846
// module chunks = 193